import React from "react";

const OurStory = () => {
  return (
    <div
      className="about-section py-5 d-flex flex-column align-items-center"
      style={{
        textAlign: "center",
        backgroundColor: "#000", // Black background
        borderRadius: "10px",
        padding: "50px 20px",
        boxShadow: "0 10px 20px rgba(255, 0, 0, 0.4)", // Red shadow for theme coherence
        animation: "fadeIn 1.5s ease-in-out",
      }}
    >
      <h1
        style={{
          fontSize: "2.8rem",
          color: "#fff", // White text for contrast
          marginBottom: "10px",
          animation: "fadeInDown 1s ease-in-out",
        }}
      >
        Everest Momo Cafe
      </h1>
      <h3
        style={{
          fontSize: "2rem",
          color: "#21438E", // Red accent for the slogan
          fontStyle: "italic",
          marginBottom: "30px",
          animation: "fadeInDown 1.2s ease-in-out",
        }}
      >
        Asian Tasty Food
      </h3>
      <p
        style={{
          fontSize: "1.2rem",
          lineHeight: "1.8",
          color: "#ccc", // Light gray for better readability
          maxWidth: "800px",
          marginBottom: "20px",
          animation: "fadeIn 1.5s ease-in-out",
        }}
      >
        At Everest Momo Cafe, we bring the authentic taste of Asia right to your
        plate. From our signature momos to a variety of flavorful dishes, we
        craft each meal with fresh ingredients and a passion for perfection.
        Join us for a journey through taste and tradition, where every bite
        tells a story.
      </p>
     
    </div>
  );
};

export default OurStory;
